<template>
  <div class="wrapper">
    <div class="paper df-l-fs" v-if="info.fin">
      
      <!-- 头部 -->
      <section class="w100p">
        <div class="boldbig tac">{{info['companyName'+_lang]}}</div>
        <div class="tac m16">（{{info['shopName'+_lang]}}）</div>
      </section>
      <!-- 信息 -->
      <section class="w100p pb8">
        <div class="df row" v-for="(x,i) in info.bases" :key="i">
          <span class="fsk0">{{$t('report.'+x.key)}}：</span>
          <span class="f1" v-html="x.value||x['value'+_lang]"></span>
        </div>
      </section>
      <!-- 表格 -->
      <section class="w100p">
        <table class="w100p">
          <thead>
            <tr class="bt">
              <th class="pt8">{{$t('report.payWay')}}</th>
              <th class="pt8">{{$t('report.tangshi')}}</th>
              <th class="pt8">{{$t('report.takeaway')}}</th>
              <th class="pt8">{{$t('report.all')}}</th>
            </tr>
          </thead>
          <tbody>
            <!-- 支付方式 -->
            <tr v-for="(x,i) in info.payways" :key="'a'+i">
              <td :class="{'pb8':i===info.payways.length-1}">{{x['name'+_lang]}}</td>
              <td :class="{'pb8':i===info.payways.length-1}">{{x.tangshi|todoublezero}}</td>
              <td :class="{'pb8':i===info.payways.length-1}">{{x.takeout|todoublezero}}</td>
              <td :class="{'pb8':i===info.payways.length-1}">{{x.total|todoublezero}}</td>
            </tr>
            <!-- 销售额 -->
            <tr class="bt bd">
              <td class="pt8 pb8">
                <div class="boldbig">{{$t('report.'+{us:'total',hk:'turnover'}[sysEnv_x])}}</div>
                <!-- <div v-if="sysEnv_x==='us'">({{$t('report.turnoverTip')}})</div> -->
              </td>
              <td class="bold">{{info.turnover.tangshi|todoublezero}}</td>
              <td class="bold">{{info.turnover.takeout|todoublezero}}</td>
              <td class="bold">{{info.turnover.total|todoublezero}}</td>
            </tr>
            <!-- <tr class="bd" v-if="sysEnv_x==='us'">
              <td class="pb8" colspan="4">
                <div>({{$t('report.turnoverTip')}})</div>
              </td>
            </tr> -->
            <!-- 服务费+小费+消费税+餐盒费+外卖折扣+优惠券 -->
            <!-- <tr v-for="(x,i) in info.paysfees" :key="'b'+i" :class="{'bt':i===0}" v-if="x.show||sysEnv_x==='us'">
              <td :class="{'pt8':i===0,'pb8':i===info.paysfees.length-1}" colspan="3">{{$t('report.'+x.key)}}</td>
              <td :class="{'pt8':i===0,'pb8':i===info.paysfees.length-1}">{{x.total|todoublezero}}</td>
            </tr> -->
            <tr v-for="(x,i) in info.paysfees" :key="'b'+i" :class="{'bt':i===0}" v-if="x.show||sysEnv_x==='us'">
              <td :class="{'pt8':i===0,'pb8':i===info.paysfees.length-1}" colspan="3">{{$t('report.'+x.key)}}</td>
              <td :class="{'pt8':i===0,'pb8':i===info.paysfees.length-1}">{{x.total|todoublezero}}</td>
            </tr>
            <!-- 具体使用的优惠券 -->
            <tr class="bt" v-if="info.coupons.length">
              <td class="pt8" colspan="2">{{$t('report.discountFee')}}</td>
              <td class="pt8">{{$t('report.count')}}</td>
              <td class="pt8">{{$t('report.amount')}}</td>
            </tr>
            <tr v-for="(x,i) in info.coupons" :key="'c'+i">
              <td :class="{'pb8':i===info.coupons.length-1}" colspan="2">{{x.ticketName}}</td>
              <td :class="{'pb8':i===info.coupons.length-1}">{{x.count|tothousands}}</td>
              <td :class="{'pb8':i===info.coupons.length-1}">({{x.total|todoublezero}})</td>
            </tr>
            <!-- 未支付 -->
            <tr class="bt">
              <td class="pt8">{{$t('report.unPayed')}}</td>
              <td class="pt8">{{info.unPayed.tangshi|todoublezero}}</td>
              <td class="pt8">{{info.unPayed.takeout|todoublezero}}</td>
              <td class="pt8">{{info.unPayed.total|todoublezero}}</td>
            </tr>
            <!-- 已退款 -->
            <tr>
              <td>{{$t('report.returnCash')}}</td>
              <td>{{info.returnCash.tangshi|todoublezero}}</td>
              <td>{{info.returnCash.takeout|todoublezero}}</td>
              <td>{{info.returnCash.total|todoublezero}}</td>
            </tr>
          </tbody>
        </table>
      </section>
      <!-- 足部 -->
      <section class="w100p pt16">
        <!-- 客流量+订单量+删除订单+删除菜品+餐厅堂食+餐厅外卖 -->
        <div class="df-c-sb row" v-for="(x,i) in info.counts" :key="i">
          <span>{{$t('report.'+x.key)}}</span>
          <span class="bt f1 line"></span>
          <span>{{x.total|tothousands}}{{$t('report.'+x.unit)}}</span>
        </div>
      </section>
      <template v-if="info.isShowMemberPart">
        <!-- 头部 -->
        <section class="w100p">
          <div class="boldbig tac bt" style="padding-top: 0.5rem;margin: 1rem 0;padding-top: 1rem;">{{$t('report.memberReport')}}</div>
        </section>
        <!-- 表格 -->
        <section class="w100p">
          <table class="w100p">
            <thead>
              <tr>
                <th>{{$t('report.payWay2')}}</th>
                <th v-if="isShowMember&&isShowMemberWallet">{{$t('member.charge')}}</th>
                <th>{{$t('report.memberFee')}}</th>
                <th>{{$t('report.memberSellFee')}}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(x,i) in info.memberFees" :key="i">
                <td :class="{'pb8':i===info.memberFees.length-1}">{{x['name'+_lang]}}</td>
                <td :class="{'pb8':i===info.memberFees.length-1}" v-if="isShowMember&&isShowMemberWallet">{{x.rechargeFee|todoublezero}}</td>
                <td :class="{'pb8':i===info.memberFees.length-1}">{{x.vipFee|todoublezero}}</td>
                <td :class="{'pb8':i===info.memberFees.length-1}">{{x.vipFeeAndOther|todoublezero}}</td>
              </tr>
              <!-- 总计 -->
              <tr class="bt">
                <td class="boldbig pt8 pb8">{{$t('report.total')}}</td>
                <td class="bold" v-if="isShowMember&&isShowMemberWallet">{{info.total.rechargeFee|todoublezero}}</td>
                <td class="bold">{{info.total.vipFee|todoublezero}}</td>
                <td class="bold">{{info.total.vipFeeAndOther|todoublezero}}</td>
              </tr>
              <!-- 净营收 -->
              <tr class="bt bd" v-if="sysEnv_x==='us'">
                <td class="pt8 pb8" colspan="3">
                  <div class="boldbig">{{$t('report.netRevenue')}}</div>
                  <div>({{$t('report.netRevenueTip')}})</div>
                </td>
                <td class="boldbig">{{info.netRevenue|todoublezero}}</td>
              </tr>
              <!-- 营收 -->
              <tr class="bt bd" v-if="sysEnv_x==='us'">
                <td class="pt8 pb8" colspan="3">
                  <div class="boldbig">{{$t('report.revenue')}}</div>
                  <div>({{$t('report.revenueTip')}})</div>
                </td>
                <td class="boldbig">{{info.revenue|todoublezero}}</td>
              </tr>
            </tbody>
          </table>
        </section>
      </template>

    </div>
  </div>
</template>

<script>
let that
export default {
  name: 'Report',
  filters: {
    todoublezero: val => {
      if (Number(val||0) >= 0) {
        if (that.sysEnv_x === 'us') {
          val = Number(val||0).toFixed(2)
        } else if (that.sysEnv_x === 'hk') {
          val = Number(val||0).toFixed(1)
        }
      } else {
        if (that.sysEnv_x === 'us') {
          // val = '-' + Number(-val||0).toFixed(2)
          val = '(' + Number(-val||0).toFixed(2) + ')'
        } else if (that.sysEnv_x === 'hk') {
          // val = '-' + Number(-val||0).toFixed(1)
          val = '(' + Number(-val||0).toFixed(1) + ')'
        }
      }
      return String(val).replace(/(\d)(?=(\d{3})+\.)/g, ($0,$1) => $1 + ',').replace(/\.$/, '')
    }
  },
  data() {
    return {
      info: {
        fin: false,
        companyName_zh: '',
        companyName_en: '',
        shopName_zh: '',
        shopName_en: '',
        bases: [
          {key:'address',value_zh:'',value_en:''},
          {key:'phone',value:''},
          {key:'date',value:''},
        ],
        payways: [],
        turnover: {},
        paysfees: [
          {key:'serviceFee',total:0,show:true}, // 服务费
          {key:'tipsFee',total:0,show:false}, // 小费
          {key:'consumptionFee',total:0,show:false}, // 消费税
          {key:'packageFee',total:0,show:true}, // 餐盒费
          {key:'takeoutDiscountFee',total:0,show:true}, // 外卖折扣
          {key:'discountFee',total:0,show:true}, // 优惠券
        ],
        coupons: [],
        unPayed: {},
        returnCash: {},
        counts: [
          {key:'dinners',total:0,unit:'unitPerson'}, // 客流量
          {key:'orderNumber',total:0,unit:'unitOrder'}, // 订单量
          {key:'tangshiOrderNumber',total:0,unit:'unitOrder'}, // 餐厅堂食
          {key:'takeoutOrderNumber',total:0,unit:'unitOrder'}, // 餐厅外卖
          {key:'takeoutPlatNumber',total:0,unit:'unitOrder'}, // 外卖平台
          {key:'deleteOrderNumber',total:0,unit:'unitOrder'}, // 删除订单
          {key:'deleteOrderItemNumber',total:0,unit:'unitCount'}, // 删除菜品
        ],
        isShowMemberPart: false,
        memberFees: [],
        total: {
          rechargeFee:0,
          vipFee:0,
          vipFeeAndOther:0
        },
        netRevenue: 0,
        revenue: 0,
      }
    }
  },
  methods: {
    getReport() {
      this.$api.print_report_search({ id: this.currentShopId }).then(res => {
        if (res.status === 0) {
          let _R = res.data
          // console.log(`%c报告:`, 'color: #f00;', _R)

          this.info.companyName_zh = _R.companyName
          this.info.companyName_en = _R.companyName
          // this.info.companyName_zh = _R.printCompanyName
          // this.info.companyName_en = _R.printCompanyName
          this.info.shopName_zh = _R.shopName_zh
          this.info.shopName_en = _R.shopName_en

          if (this.sysEnv_x==='us') {
            const arr_zh = JSON.parse(JSON.stringify(_R.addressList_zh))
            this.info.bases[0].value_zh = arr_zh[0] + '<br/>'
            arr_zh.splice(0, 1)
            this.info.bases[0].value_zh += arr_zh.join(' ')
            const arr_en = JSON.parse(JSON.stringify(_R.addressList_en))
            this.info.bases[0].value_en = arr_en[0] + '<br/>'
            arr_en.splice(0, 1)
            this.info.bases[0].value_en += arr_en.join(' ')
          } else if (this.sysEnv_x==='hk') {
            // this.info.bases[0].value_zh = _R.addressList_zh.join(' ')
            // this.info.bases[0].value_en = _R.addressList_en.join(' ')
            this.info.bases[0].value_zh = _R.addressList_zh[3]
            this.info.bases[0].value_en = _R.addressList_en[3]
          }

          this.info.bases[1].value = _R.phone
          // this.info.bases[2].value = _R.date.replace(/\-/g, '/')
          this.info.bases[2].value = _R.date

          this.info.payways = _R.payTypeList

          this.info.turnover = _R.totalPayType

          this.info.paysfees[0].total = _R.serviceFee
          this.info.paysfees[1].total = _R.tipsFee
          this.info.paysfees[2].total = _R.consumptionFee
          this.info.paysfees[3].total = _R.packageFee
          this.info.paysfees[4].total = '-' + _R.takeoutDiscountFee
          this.info.paysfees[5].total = '-' + _R.discountFee

          this.info.coupons = _R.discountReportList

          this.info.unPayed = _R.unPayed
          this.info.returnCash = _R.returnCash

          this.info.counts[0].total = _R.dinners
          this.info.counts[1].total = _R.orderNumber
          this.info.counts[2].total = _R.tangshiOrderNumber
          this.info.counts[3].total = _R.takeoutOrderNumber
          this.info.counts[4].total = _R.takeoutPlatNumber
          this.info.counts[5].total = _R.deleteOrderNumber
          this.info.counts[6].total = _R.deleteOrderItemNumber

          this.info.isShowMemberPart = _R.customerReportOpen

          this.info.memberFees = _R.customerPayTypeList

          this.info.total = _R.customerTotalPayType

          this.info.netRevenue = _R.netSale

          this.info.revenue = _R.netSaleWithTax

          this.info.fin = true

        } else { this._status(res) }
      })
    },
  },
  created() {
    that = this
  },
}
</script>

<style lang="scss" scoped>
// *{margin: 0;padding: 0;box-sizing: border-box;font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Liberation Sans", "PingFang SC", "Microsoft YaHei", "Hiragino Sans GB", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti", SimHei, SimSun, "WenQuanYi Zen Hei Sharp", sans-serif;}
*{margin: 0;padding: 0;box-sizing: border-box;}
// 1rem = 16px
.wrapper{
  height: 100%;overflow: scroll;flex-shrink: 0;
  .paper{
    width: 30rem;padding: 1rem;background: #fff;overflow: scroll;margin-bottom: 2rem;
    
    table{table-layout: fixed;}
    tr, .row{min-height: 24px;line-height: 24px;}
    tr td:nth-child(n+2), tr th:nth-child(n+2){text-align: right;}
  
    .bt{border-top: 1px dashed #000;}
    .bb{border-bottom: 1px dashed #000;}
  
    .m16{margin: 1rem 0;}
    .mt8{margin-top: 0.5rem;}
    .pt8{padding-top: 0.5rem;}
    .pt16{padding-top: 1rem;}
    .mb8{margin-bottom: 0.5rem;}
    .pb8{padding-bottom: 0.5rem;}
  
    .tac{text-align: center;}
    .bold{font-weight: bold;}
    .boldbig{font-size: 1.5rem;font-weight: bold;}
    .line{height: 0;position: relative;top: 0;bottom: 0;margin: auto 1rem;}
  }
}
</style>